import { render } from "./DashboardOrganizationsDrawerPanel.vue?vue&type=template&id=291ace32&scoped=true"
import script from "./DashboardOrganizationsDrawerPanel.vue?vue&type=script&lang=js"
export * from "./DashboardOrganizationsDrawerPanel.vue?vue&type=script&lang=js"

import "./DashboardOrganizationsDrawerPanel.vue?vue&type=style&index=0&id=291ace32&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291ace32"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QIcon,QItem,QBtn,QBtnGroup});
